import { api } from './api';
import { setUser, setToken, setLoading, clearAuth } from '../store/slices/authSlice';

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setToken(data.access_token));
          dispatch(setUser(data.user));
        } catch (error) {
          console.error('Login failed:', error);
        }
      },
    }),

    register: builder.mutation({
      query: (userData) => ({
        url: '/auth/signup',
        method: 'POST',
        body: userData,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setToken(data.access_token));
          dispatch(setUser(data.user));
        } catch (error) {
          console.error('Registration failed:', error);
        }
      },
    }),

    fetchUser: builder.query({
      query: () => '/auth/me',
      providesTags: ['User'],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setUser(data));
        } catch (error) {
          console.error('Failed to fetch user:', error);
          dispatch(clearAuth());
        } finally {
          dispatch(setLoading(false));
        }
      },
    }),

    getUserInfo: builder.query({
      query: () => '/users/info',
      providesTags: ['User'],
    }),

    updatePlan: builder.mutation({
      query: (plan) => ({
        url: '/settings/change-plan',
        method: 'POST',
        body: { plan },
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setUser(data.user || data));
        } catch (error) {
          console.error('Failed to update plan:', error);
        }
      },
      invalidatesTags: ['User'],
    }),
  }),
});

export const { useLoginMutation, useRegisterMutation, useUpdatePlanMutation } =
  authApi;

export const { useFetchUserQuery, useGetUserInfoQuery } = authApi;
